import React, { useEffect, useState } from 'react';
import { Stack, Group, Select } from '@mantine/core';
import ModalWrapper from '../../components/elements/ModalWrapper';
import Button from '../../components/elements/Button';
import { FiFilter } from 'react-icons/fi';
import { Controller, useForm } from 'react-hook-form';
import dayjs from 'dayjs';
import { generateYearList } from '../../utilities/generateYearList';

interface ChartFilterCTMProps {
  isOpen: boolean;
  onClose: () => void;
  onFilter: (data: any) => void;
  onReset: () => void;
}

const typeOptions = [
  { label: 'Participant', value: '001' },
  { label: 'Facilitator', value: '002' },
  { label: 'Action Research and Publication', value: '003' },
  { label: 'Coaching and Mentoring', value: '004' }
];

const ChartFilterCTM: React.FC<ChartFilterCTMProps> = ({
  isOpen,
  onClose,
  onFilter,
  onReset
}) => {
  const { control, reset, handleSubmit } = useForm({
    defaultValues: {
      yearFrom: null,
      yearTo: null,
      typeTask: null
    }
  });

  const onSubmit = (data: any) => {
    onFilter(data);
    onClose();
  };

  const handleReset = () => {
    reset({
      yearFrom: null,
      yearTo: null,
      typeTask: null
    });
    onClose();
    onReset();
  };

  const [selectedYearFrom, setSelectedYearFrom] = useState(
    dayjs().get('year').toString()
  );

  const [selectedYearTo, setSelectedYearTo] = useState(
    dayjs().get('year').toString()
  );

  return (
    <ModalWrapper title="Filter" isVisible={isOpen} onClose={onClose}>
      <form onSubmit={handleSubmit(onSubmit)}>
      <Stack>
        <Controller
          name="typeTask"
          control={control}
          render={({ field }) => (
            <Select
              label="Select Type"
              data={typeOptions}
              placeholder="Select a Type"
              {...field}
            />
          )}
        />
      <Group gap={16} justify="space-between">
        <Controller
          name="yearFrom"
          control={control}
          render={({ field }) => (
            <Select
              label="Year From"
              value={selectedYearFrom}
              data={generateYearList('before-now').sort(
              (a, b) => Number(b) - Number(a)
              )}
              {...field}
              placeholder="Select a Year"
            />
          )}
        />
        <Controller
          name="yearTo"
          control={control}
          render={({ field }) => (
            <Select
              label="Year To"
              value={selectedYearTo}
              data={generateYearList('before-now').sort(
              (a, b) => Number(b) - Number(a)
              )}
              placeholder="Select a Year"
              {...field}
            />
          )}
        />
      </Group>
      <Group justify='flex-end' mt="md" gap={10}>
        <Button variant='error-beelajar' onClick={handleReset}>
          Reset Filter
        </Button>
        <Button type="submit">
          <FiFilter />
            Apply Filter
        </Button>
      </Group>
      </Stack>
      </form>
    </ModalWrapper>
  );
};

export default ChartFilterCTM;
